/*
 * @Author: guojiangwei
 * @Date: 2022-04-07 19:45:55
 * Copyright © Leedarson. All rights reserved.
 */
class NativeWebView {
  constructor({ native }) {
    this.native = native;
  }

  /**
   * 关闭 WebView
   */
  close() {
    return this.native.send({
      key: 'WebView.close',
    });
  }

  /**
   * 打开 WebView
   */
  // open({ ...options }) {
  //   return this.native.send({
  //     key: 'WebView.open',
  //     ...options,
  //   });
  // }

  /**
   * 设置消息回调
   * @param {Callback} callback
   * @returns {void}
   */
  // onMessage(callback) {
  //   this.native.on('WebView.onMessage', callback);
  // }

  /**
   * 取消消息回调
   * @param {Callback} [callback]
   * @returns {void}
   */
  // offMessage(callback) {
  //   this.native.off('WebView.onMessage', callback);
  // }
}

export default NativeWebView;
